<!-- TODO: Multilang -->
<template>
  <v-text-field
    v-model="search_text"
    id="explorerHeaderSearchableText"
    name="explorerHeaderSearchableText"
    ref="explorerHeaderSearchableText"
    prepend-inner-icon="mdi-magnify"
    :placeholder="$vuetify.lang.translator('search_text')"
    single-line
    @input="isTyping = true"
    class="explorer-searchable-text"
    :class="{ 'closed' : searchClosed}"
    solo
    flat
    clearable    
    dense
    filled
    hide-details
    background-color="white"
    @click:prepend-inner="toogleSearch($event)"
    @blur="toogleSearch($event)"
  />
</template>

<style lang="scss">
 @import "@/sass/explorer.scss";
</style>

<script>
import debounce from 'lodash/debounce';

export default {
  name: 'SearchText',
  data() { 
    return {
      isTyping: false,
      search_text: '',
      searchClosed: true,
    }
  },
  watch: {
    // launch when stop typing wait 1s.
    search_text: debounce(function() {
      this.isTyping = false;
    }, 1000), 

    isTyping: function(value) {
      if (!value) {
        if (this.search_text && this.search_text.length >= 3)
          this.$emit("input", this.search_text);
        if (!this.search_text)
          this.$emit("input", '')
      }
    }
  },
  methods: {
    toogleSearch: function(evt) {
      if (this.searchClosed)
        this.$refs.explorerHeaderSearchableText.focus();
      if (!this.search_text)
        this.searchClosed = !this.searchClosed
      else
        this.$emit("input", this.search_text);
    },
  },
}
</script>
